import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GralUsr } from '../entity/GralUsr';
import { GralUsrRole } from '../entity/GralUsrRole';
import { Config } from '../config/config';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private _usr: GralUsr;
  private _token: string;
  private config: Config = new Config();
  constructor(private http: HttpClient) { }

  public get usuario(): GralUsr {
    //this.logout();
    if (this._usr != null) {
      return this._usr;
    } else if (this._usr == null && localStorage.getItem('usuario')) {
      this._usr = JSON.parse(localStorage.getItem('usuario')) as GralUsr;
      return this._usr;
    }
    return new GralUsr();
  }
  public setUsuario(user: GralUsr) {
    localStorage.setItem('usuario', JSON.stringify(user));
  }
  public get empresa(): number {
    return this.usuario.empresa_seleccionada.id;
  }
  public get empresa_info_actual(): any {
    return this.usuario.empresa_seleccionada;
  }
  public get sucursal(): number {
    return this.usuario.empresa_seleccionada.gral_suc_id;
  }
  public get empresas(): any {
    return this._usr.empresas;
  }
  public get sucursales(): any {
    return JSON.parse(localStorage.getItem('sucursales')) as any;
  }
  public get ejercicio(): number {
    return parseInt(localStorage.getItem('ejercicio_seleccionado'));
  }
  public get ejercicios(): any {
    return JSON.parse(localStorage.getItem('ejercicios')) as any;
  }
  //////////////////////////////////////////////////////////////////////////////
  public get token(): string {
    if (this._token != null) {
      return this._token;
    } else if (this._token == null && localStorage.getItem('token')) {
      this._token = localStorage.getItem('token');
      return this._token;
    }
    return null;
  }
  //////////////////////////////////////////////////////////////////////////////
  login(usuario: GralUsr): Observable<any> {
    const credenciales = btoa('ApiBase' + ':' + '123456');
    let identificador = location.hostname.replace('http://', '').replace('https://', '').split('.')[0];
    identificador = identificador.replace('localhost', 'prueba');
    // identificador = identificador.replace('localhost', 'erp');
    //identificador = 'prueba';
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + credenciales,
      'sub-domain': identificador
    });
    const params = new URLSearchParams();
    params.set('grant_type', 'password');
    params.set('username', usuario.username);
    params.set('password', usuario.passwordCrypt);
    return this.http.post<any>(Config.URL_BASE + '/oauth/token'
      , params.toString(), { headers: httpHeaders }).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
  }
  solicitarCambioPassword(email: String): Observable<any> {
    return this.http.put<any>(Config.URL_BASE + '/GralUsr/put/cambio/pass/' + email, null).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  findUsrByIdTran(idTran: String): Observable<any> {
    return this.http.get<any>(Config.URL_BASE + '/GralUsr/get/by/' + idTran).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  //////////////////////////////////////////////////////////////////////////////
  changePassword(entity: UsrPassword): Observable<any> {
    return this.http.put<any>(Config.URL_BASE + '/GralUsr/put/password', entity).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  newPassword(entity: UsrPassword): Observable<any> {
    return this.http.put<any>(Config.URL_BASE + '/GralUsr/put/new/password', entity).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getRoleByUsrId(id: number): Observable<any> {
    return this.http.get<any>(Config.URL_BASE + '/GralUsr/get/role_usr/' + id).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

   getEmpByUsrId(id: number): Observable<any> {
    return this.http.get<any>(Config.URL_BASE + '/gral_emp/get/by/usr/' + id).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  //////////////////////////////////////////////////////////////////////////////
  guardarUsuario(accessToken: string): Observable<any> {
    console.log(accessToken);
    const payload = this.obtenerDatosToken(accessToken);
    this._usr = new GralUsr();
    this._usr.id = payload.id;
    this._usr.username = payload.usuario;
    this._usr.password = payload.password;
    this._usr.publicId = payload.publicId;
    this._usr.picture = payload.picture;
    this._usr.email = payload.email;
   // this._usr.empresas = payload.empresas_test;
   // this._usr.empresa_seleccionada = this._usr.empresas[0];

   return this.getEmpByUsrId(payload.id).pipe(
        tap(response => {
            this._usr.empresas = response.contenido;
            this._usr.empresa_seleccionada = this._usr.empresas[0];
            localStorage.setItem('usuario', JSON.stringify(this._usr));
        })
    );

    
    //localStorage.setItem('empresas', JSON.stringify(payload.empresas));
    //localStorage.setItem('sucursales', JSON.stringify(payload.sucursales));
  }
  seleccionarEmpresa(empresa: any) {
    this._usr = this.usuario;
    this._usr.empresa_seleccionada = empresa;
    localStorage.setItem('usuario', JSON.stringify(this._usr));
  }
  //////////////////////////////////////////////////////////////////////////////
  guardarToken(accessToken: string): void {
    this._token = accessToken;
    // console.log(accessToken);
    localStorage.setItem('token', accessToken);
  }
  //////////////////////////////////////////////////////////////////////////////
  obtenerDatosToken(accessToken: string): any {

    if (accessToken != null) {
      return JSON.parse(atob(accessToken.split('.')[1]));
    }
    return null;
  }
  //////////////////////////////////////////////////////////////////////////////
  isAuthenticated(): boolean {
    const payload = this.obtenerDatosToken(this.token);
    if (payload != null && payload.user_name && payload.user_name.length > 0) {
      return true;
    }
    return false;
  }
  //////////////////////////////////////////////////////////////////////////////
  logout(): void {
    this._token = null;
    this._usr = null;
    const poliza_tmp = localStorage.getItem('poliza_tmp');
    localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.setItem('poliza_tmp', poliza_tmp);
  }
  //////////////////////////////////////////////////////////////////////////////
  hasRoleAndPermission(role: string[]): boolean {
    const usr_role: GralUsrRole[] = this.usuario.gral_usr_role;
    for (let i = 0; i < usr_role.length; i++) {
      if (usr_role[i].role.authority === role[0]) {
        switch (role[1].toUpperCase()) {
          case 'READ':
            if (usr_role[i].gral_role_read === true) {
              return true;
            }
            break;
          case 'WRITE' || 'CREATE':
            if (usr_role[i].gral_role_write === true) {
              return true;
            }
            break;
          case 'UPDATE':
            if (usr_role[i].gral_role_update === true) {
              return true;
            }
            break;
          case 'DELETE':
            if (usr_role[i].gral_role_delete === true) {
              return true;
            }
            break;
        }
      } else if (usr_role[i].role.name === 'ADMIN') {
        return true;
      }
    }
    return true;
  }

}
export class UsrPassword {
  id: number;
  oldPassword: String;
  newPassword: String;
}
